import { HStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import React from 'react';

import { ProductButtonProps } from '../..';
import { BookOffersButton } from '../../../../../EquityOffersBookModal/components/BookOffersButton';
import { BatchTicketButton } from '../../components/BatchTicketButton';

export const EquityButton: React.FC<ProductButtonProps<'equity'>> = (props) => {
  return (
    <HStack space={Spacing['inline.nano']}>
      <BookOffersButton equity={props.offer} />
      <BatchTicketButton {...props} idSelector="productIdNormalized" />
    </HStack>
  );
};
